import { render } from "./DropdownItem.vue?vue&type=template&id=ab2d9308&scoped=true&ts=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"

import "./DropdownItem.vue?vue&type=style&index=0&id=ab2d9308&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2d9308"]])

export default __exports__